export default "__VITE_ASSET__BWAVXoA2__"